import styles from "./NewOrganisation.module.scss";
import { GreetingsHeader } from '../../components/common/GreetingsHeader';
import { AddOrganisationForm } from '../../components/AddOrganisationForm';
import React, { useContext } from 'react';
import { UserContext } from '../../context/UserContext';
import { Navigate } from 'react-router-dom';

export const NewOrganisation = () => {
    const userContext = useContext(UserContext)
    if(userContext?.organisation?.id !== 1) {
        return <Navigate to='/library/home' />
    }

    return (
        <div className={styles.wrapper}>
            <GreetingsHeader title="Create New organisation" subtitle=""/>
            <section className={styles.navigate}>
                <AddOrganisationForm />
            </section>
        </div>
    )
};
